import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';

import { Observable, catchError, map, of } from 'rxjs';

import { ENVIRONMENT, Environment } from '@fantaz/shared/app-config';
import {
  CasualTournamentEntity,
  HomeSlider,
} from '@fantaz/shared/data-access/models';

import { UtilsService } from './utils.service';

const MOBILE_TOURNAMENT_COUNT = 4;
const DESKTOP_TOURNAMENT_COUNT = 12;

@Injectable({
  providedIn: 'root',
})
export class HomeService {
  constructor(
    @Inject(ENVIRONMENT) private appConfig: Environment,
    private http: HttpClient,
    private utilsService: UtilsService,
  ) {}

  fetchHomeSliderProps(): Observable<HomeSlider> {
    const endpoint = `${this.appConfig.baseURL}/assets/carousel.json`;
    return this.http.get<HomeSlider>(endpoint).pipe(
      catchError((error) => {
        console.error('Failed to fetch home slider props:', error);
        // Return a default disabled slider instead of throwing
        return of({ enabled: false, resources: [] } as HomeSlider);
      }),
    );
  }

  getNumberOfFeaturedTournaments(): number {
    return window.innerWidth < 768
      ? MOBILE_TOURNAMENT_COUNT
      : DESKTOP_TOURNAMENT_COUNT;
  }

  fetchFeaturedTournaments(): Observable<CasualTournamentEntity[]> {
    const endpoint = `${
      this.appConfig.apiBaseUrl
    }/api/public/featured-tournaments?limit=${this.getNumberOfFeaturedTournaments()}`;
    return this.http.get<CasualTournamentEntity[]>(endpoint).pipe(
      map((tournaments) => {
        return tournaments.map((tournament) => {
          // add lifeExperience
          // TODO: Move to api service
          if (
            tournament &&
            tournament.eventSchedules &&
            tournament.eventSchedules.length > 0
          ) {
            const eventScheduler = tournament.eventSchedules.find((e) => {
              return e.lifeExperience;
            });

            if (eventScheduler) {
              tournament.lifeExperience = true;
            }
            this.utilsService.getPrizeDetails(tournament);
          }

          return {
            ...tournament,
            metadata: {
              ...tournament.metadata,
              tags:
                tournament && tournament.metadata && tournament.metadata.tags
                  ? (tournament.metadata.tags as unknown as string).split(',')
                  : [
                      tournament.lifeExperience
                        ? 'Prize Tournament'
                        : 'Cash Tournament',
                    ], // by default use Prize Tournament
            },
          };
        });
      }),
    );
  }
}
